import { render } from "./sliderFilterIcon.vue?vue&type=template&id=a1276638"
import script from "./sliderFilterIcon.vue?vue&type=script&lang=js"
export * from "./sliderFilterIcon.vue?vue&type=script&lang=js"
script.render = render

export default script